type SelfServeQueryKeys = 'self_serve.api_keys';

export const SELF_SERVE_API = {
  KEYS: 'self_serve.api_keys' as SelfServeQueryKeys,
};
